var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Router } from "@lit-labs/router";
import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";
import "./ProductsListPage";
import "./AboutPage";
import "./ProductDetailPage";
import "./ViewCartProductsPage";
import "./NotFoundPage";
import "./ToastNotificationPage";
import "./FeedbackPage";
export let AppRoutesPage = class AppRoutesPage extends LitElement {
    constructor() {
        super(...arguments);
        this.router = new Router(this, [
            { path: "/", render: () => html `<product-list></product-list>` },
            { path: "/products", render: () => html `<product-list></product-list>` },
            {
                path: "/products/:productId",
                render: ({ productId }) => {
                    return html `<product-detail productId="${productId}"></product-detail>`;
                },
            },
            {
                path: "/about",
                render: () => {
                    return html `<about-page></about-page>`;
                },
            },
            {
                path: "/feedback",
                render: () => {
                    return html `<feedback-page></feedback-page>`;
                },
            },
            {
                path: "/cart",
                render: () => {
                    return html `<view-cart-products></view-cart-products>`;
                },
            },
            { path: "/*", render: () => html `<not-found></not-found>` },
        ]);
    }
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        return html `
      <main>${this.router.outlet()}</main>`;
    }
};
AppRoutesPage = __decorate([
    customElement("app-routes")
], AppRoutesPage);
